module.exports = __webpack_public_path__ + "img/discord.0b532b95.svg";